import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ListItem as DesignSystemListItem } from '@uptime/design-system/components/ListItem';
import { ListItemButton } from '@uptime/design-system/components/ListItemButton';

interface Props {
  children: React.ReactNode;
  to?: string;
  onClick?: () => void;
  selected?: boolean;
}

export const ListItem = ({ to, children, onClick, selected, ...rest }: Props) => {
  const location = useLocation();

  const isSelected = selected ?? (to ? location.pathname.includes(to) : false);

  return (
    <DesignSystemListItem disablePadding onClick={onClick} data-testid="leftMenuItem">
      <ListItemButton variant="sidebar" component={Link} to={to} selected={isSelected} {...rest}>
        {/* @ts-expect-error types mismatch */}
        {children}
      </ListItemButton>
    </DesignSystemListItem>
  );
};
